"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BDNPortSearch = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_select_1 = __importDefault(require("react-select"));
const useFetch_1 = __importDefault(require("../../../../hooks/useFetch"));
const apiUtils_1 = require("../../../../util/apiUtils");
const BDNPortSearch = ({ selectedPortData, onChange, }) => {
    const [searchQuery, setSearchQuery] = (0, react_1.useState)("");
    const [selected, setSelected] = (0, react_1.useState)(null);
    const [searchError, setSearchError] = (0, react_1.useState)(null);
    const [displayPorts, setDisplayPorts] = (0, react_1.useState)(undefined);
    // Initialize selected port when editing
    (0, react_1.useEffect)(() => {
        if (selectedPortData) {
            setSelected({
                value: selectedPortData,
                label: `${selectedPortData.name} (${selectedPortData.un_code})`,
            });
        }
        else {
            setSelected(null);
        }
    }, [selectedPortData?.id]);
    // Fetch ports based on search query
    const [portsResponse, setUrl, setBody] = (0, useFetch_1.default)(undefined, undefined);
    // Debounced search effect
    (0, react_1.useEffect)(() => {
        const trimmed = searchQuery.trim();
        const isNumeric = /^\d+$/.test(trimmed);
        const canSearch = trimmed.length >= 3 || isNumeric;
        if (!canSearch) {
            setDisplayPorts(undefined);
            setSearchError(null);
            return;
        }
        const timeoutFunction = setTimeout(() => {
            setSearchError(null);
            setBody(JSON.stringify({
                search: searchQuery,
            }));
            setUrl("admin/ports_search.json");
        }, 300);
        return () => clearTimeout(timeoutFunction);
    }, [searchQuery, setUrl, setBody]);
    // Handle search response
    (0, react_1.useEffect)(() => {
        if (portsResponse.status === apiUtils_1.LoaderStatus.Success && portsResponse.data) {
            setSearchError(null);
            setDisplayPorts(portsResponse.data);
        }
        else if (portsResponse.status === apiUtils_1.LoaderStatus.Error) {
            setSearchError("Search failed; please try again.");
            setDisplayPorts(undefined);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [portsResponse.status]);
    // Handle search input change
    const handleQueryChange = (value) => {
        setSearchQuery(value);
    };
    // Convert ports to Select options
    const options = (0, react_1.useMemo)(() => {
        if (displayPorts && Array.isArray(displayPorts)) {
            return displayPorts.map((port) => ({
                value: port,
                label: `${port.name} (${port.un_code})`,
            }));
        }
        return [];
    }, [displayPorts]);
    // Handle port selection
    const handleSelectPort = (option) => {
        if (option) {
            setSelected(option);
            onChange(option.value);
        }
        else {
            setSelected(null);
        }
    };
    return ((0, jsx_runtime_1.jsx)(react_select_1.default, { isClearable: true, isSearchable: true, placeholder: "\u2026Search for port", value: selected, options: options, onChange: handleSelectPort, onInputChange: handleQueryChange, isLoading: portsResponse.status === apiUtils_1.LoaderStatus.Loading, noOptionsMessage: () => {
            if (searchError) {
                return searchError;
            }
            if (searchQuery.trim().length < 3) {
                return "Type at least 3 characters to search";
            }
            return "No ports found";
        } }));
};
exports.BDNPortSearch = BDNPortSearch;
